import { userLanguage, ValidLanguages } from '$translations/index';
import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import { GetAllTenantsOutput, TenantBuilder } from '../tenant.types';

export const getAllTenants = (builder: TenantBuilder) =>
  builder.query<GetAllTenantsOutput, void>({
    query: () => ({
      url: `/tenants`,
      method: 'GET',
    }),
    transformResponse: (response: { Id: number; Name: string }[]) => {
      return response.map(({ Id, Name }) => ({
        Id,
        title: Name,
      }));
    },
    transformErrorResponse: (error) => {
      errorHandler(
        '[setTenants]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.TenantError
          : ErrorMessageEn.TenantError,
        error,
        true
      );
      return error.data;
    },
  });
